import * as tslib_1 from "tslib";
import { first } from 'rxjs/internal/operators/first';
import { Deferred } from '../classes/deferred';
import { environment } from '../environment';
var StorageService = /** @class */ (function () {
    function StorageService(backupServices, useSessionStorage) {
        var _this = this;
        //handle storage providers
        if (useSessionStorage) {
            this.storageProvider = window.sessionStorage;
            this.storageType = 'session';
        }
        else {
            this.storageProvider = window.localStorage;
            this.storageType = 'local';
        }
        if (backupServices) {
            this.userSettingsService = backupServices.userSettingsService;
            backupServices.authService.GetCurrentUser().subscribe(function (user) {
                if (user) {
                    _this.userEmail = user.emailAddress;
                }
                else {
                    _this.userEmail = null;
                }
            });
        }
    }
    Object.defineProperty(StorageService.prototype, "canBackup", {
        get: function () { return this.userSettingsService && this.userEmail; },
        enumerable: true,
        configurable: true
    });
    /**
     * Saves a provided value to storage
     * @param key - Key to store the value at
     * @param value - Value to store
     * @returns Boolean indicating success of the save
     */
    StorageService.prototype.set = function (key, value, caller, localOnly) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var error_1;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        this.storageProvider.setItem(key, JSON.stringify(value));
                        if (!!localOnly) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.setUserSetting(key, value)];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        window.dispatchEvent(new CustomEvent('itemInserted', { detail: { key: key, caller: caller } }));
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _a.sent();
                        return [2 /*return*/, false];
                    case 4: return [2 /*return*/, true];
                }
            });
        });
    };
    /**
     * Retrieve the value stored at a specific key in the original base type it was saved as.
     * @remarks
     * Verify type coming back matches the type expected
     * @param key - Key to retrieve value from
     * @returns Parsed version of the string saved in Storage or null if parse fails or types do not match
     */
    StorageService.prototype.get = function (key) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var res, usRes;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        res = this.storageProvider.getItem(key);
                        if (!!res) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.getUserSetting(key)];
                    case 1:
                        usRes = _a.sent();
                        if (usRes) { // Cache locally
                            this.set(key, usRes, null, true);
                            return [2 /*return*/, usRes];
                        }
                        return [3 /*break*/, 3];
                    case 2: return [2 /*return*/, JSON.parse(res)];
                    case 3: return [2 /*return*/, null];
                }
            });
        });
    };
    /**
     * Set a property of a specified name to an object at or nested in another object at the key provided in Storage
     * @param key - Key of root object in Storage
     * @param nestedPath - Path to a nested object to modify ([] if no nesting present in use case)
     * @param propertyName - Property name to set on the object
     * @param value - Value of property to set on the object
     * @returns Returns boolean indicating success of the property setting
     */
    StorageService.prototype.setPropertyOfObject = function (key, nestedPath, propertyName, value, caller) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var e_1, _a, objAtKey, currentPlace, nestedPath_1, nestedPath_1_1, p, objToModify;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.get(key)];
                    case 1:
                        objAtKey = _b.sent();
                        if (!objAtKey || typeof objAtKey !== 'object') {
                            objAtKey = {};
                        }
                        currentPlace = objAtKey;
                        try {
                            for (nestedPath_1 = tslib_1.__values(nestedPath), nestedPath_1_1 = nestedPath_1.next(); !nestedPath_1_1.done; nestedPath_1_1 = nestedPath_1.next()) {
                                p = nestedPath_1_1.value;
                                currentPlace = currentPlace[p];
                                if (!currentPlace) {
                                    return [2 /*return*/, false];
                                }
                            }
                        }
                        catch (e_1_1) { e_1 = { error: e_1_1 }; }
                        finally {
                            try {
                                if (nestedPath_1_1 && !nestedPath_1_1.done && (_a = nestedPath_1.return)) _a.call(nestedPath_1);
                            }
                            finally { if (e_1) throw e_1.error; }
                        }
                        objToModify = currentPlace;
                        objToModify[propertyName] = value;
                        return [2 /*return*/, this.set(key, objAtKey, caller)];
                }
            });
        });
    };
    /**
     * Modifies an array at the key or nested in an object at the specified key at the specified nestedObjKey to have the value provided appended to it
     * @param key - Key that the object is stored in in Storage
     * @param nestedPath - Path to the array through the object hierarchy. Must end with property name of the array to modify or empty to modify an array at the provided storage key
     * @param value - Value to be appended to the array
     * @returns Boolean value indicating success of appending
     */
    StorageService.prototype.appendToArray = function (key, nestedPath, value, caller) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var e_2, _a, objAtKey, currentPlace, nestedPath_2, nestedPath_2_1, p, arr;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.get(key)];
                    case 1:
                        objAtKey = _b.sent();
                        if (!objAtKey || typeof objAtKey !== 'object') {
                            return [2 /*return*/, false];
                        }
                        currentPlace = objAtKey;
                        try {
                            for (nestedPath_2 = tslib_1.__values(nestedPath), nestedPath_2_1 = nestedPath_2.next(); !nestedPath_2_1.done; nestedPath_2_1 = nestedPath_2.next()) {
                                p = nestedPath_2_1.value;
                                currentPlace = currentPlace[p];
                                if (!currentPlace) {
                                    return [2 /*return*/, false];
                                }
                            }
                        }
                        catch (e_2_1) { e_2 = { error: e_2_1 }; }
                        finally {
                            try {
                                if (nestedPath_2_1 && !nestedPath_2_1.done && (_a = nestedPath_2.return)) _a.call(nestedPath_2);
                            }
                            finally { if (e_2) throw e_2.error; }
                        }
                        arr = currentPlace;
                        if (!arr || !Array.isArray(arr)) {
                            return [2 /*return*/, false];
                        }
                        //add new value and save obj to Storage
                        arr.push(value);
                        return [2 /*return*/, this.set(key, objAtKey, caller)];
                }
            });
        });
    };
    /**
     * Removes a value from an array at the key provided or nested in an object stored in Storage
     * @param key - Key the object is stored in in Storage
     * @param nestedPath - Path to the array through the object hierarchy. Must end with property name of the array to modify or empty if array is stored at the key in storage
     * @param value - Value to remove from the array
     * @returns Boolean indicating success of removal
     */
    StorageService.prototype.removeFromArray = function (key, nestedPath, value, caller) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var e_3, _a, objAtKey, currentPlace, nestedPath_3, nestedPath_3_1, p, arr, elementIndex;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.get(key)];
                    case 1:
                        objAtKey = _b.sent();
                        if (!objAtKey || typeof objAtKey !== 'object') {
                            return [2 /*return*/, false];
                        }
                        currentPlace = objAtKey;
                        try {
                            for (nestedPath_3 = tslib_1.__values(nestedPath), nestedPath_3_1 = nestedPath_3.next(); !nestedPath_3_1.done; nestedPath_3_1 = nestedPath_3.next()) {
                                p = nestedPath_3_1.value;
                                currentPlace = currentPlace[p];
                                if (!currentPlace) {
                                    return [2 /*return*/, false];
                                }
                            }
                        }
                        catch (e_3_1) { e_3 = { error: e_3_1 }; }
                        finally {
                            try {
                                if (nestedPath_3_1 && !nestedPath_3_1.done && (_a = nestedPath_3.return)) _a.call(nestedPath_3);
                            }
                            finally { if (e_3) throw e_3.error; }
                        }
                        arr = currentPlace;
                        if (!arr || !Array.isArray(arr)) {
                            return [2 /*return*/, false];
                        }
                        elementIndex = arr.findIndex(function (item) { return item === value; });
                        if (elementIndex === -1) {
                            return [2 /*return*/, false];
                        }
                        //remove the found element and save it to storage
                        arr = arr.splice(elementIndex, 1);
                        return [2 /*return*/, this.set(key, objAtKey, caller)];
                }
            });
        });
    };
    /**
     * Checks if the storage has the given key
     * @param key - Key the object is stored in in Storage
     * @returns Boolean indicating if the key exist
     */
    StorageService.prototype.hasKey = function (key) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var retVal;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        retVal = this.storageProvider.getItem(key) !== null;
                        if (!!retVal) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.getUserSetting(key)];
                    case 1:
                        retVal = !!(_a.sent());
                        _a.label = 2;
                    case 2: return [2 /*return*/, retVal];
                }
            });
        });
    };
    StorageService.prototype.getUserSetting = function (name) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var retVal;
            return tslib_1.__generator(this, function (_a) {
                if (!this.canBackup) {
                    return [2 /*return*/, null];
                }
                retVal = new Deferred();
                this.userSettingsService.GetSettingValue(name, environment.pdauthAppName, this.userEmail).pipe(first()).subscribe(function (result) {
                    retVal.resolve(result);
                });
                return [2 /*return*/, retVal.promise];
            });
        });
    };
    StorageService.prototype.setUserSetting = function (name, value) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.canBackup) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.userSettingsService.SetSettingValue(name, value, this.userEmail, environment.pdauthAppName)];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    return StorageService;
}());
export { StorageService };
